import { z } from 'zod';
export const timesheetsClockCommandIdSchema = z.string().uuid();
export const timesheetsCurrentProjectSuggestionCapability = 'timesheets.current-project-suggestion.v1';
export const timesheetsTimeEntryIdSchema = z.string().uuid();
export const timesheetsEntryStateSchema = z.enum([
    'active',
    'completed',
    'needs-correction',
]);
export const timesheetsEntryKindSchema = z.enum(['work', 'break']);
export const timesheetsClockBreakTypeSchema = z.enum(['lunch', 'rest', 'personal', 'other']);
export const timesheetsBillingCodeSchema = z.enum([
    'general',
    'after_hours',
    'emergency',
    'biohazard',
    'on_call',
    'drive_time',
    'admin',
    'prep',
    'break',
]);
export const timesheetsEntrySourceSchema = z.enum([
    'web',
    'mobile',
    'offline_replay',
    'manual',
    'import',
    'crew_allocation',
]);
export const timesheetsWorkReferenceSchema = z.strictObject({
    type: z.literal('project'),
    id: z.string().uuid(),
    label: z.string().trim().min(1).max(240),
});
export const timesheetsClockEntrySchema = z.strictObject({
    id: timesheetsTimeEntryIdSchema,
    tenantId: z.string().uuid(),
    membershipId: z.string().uuid(),
    state: timesheetsEntryStateSchema,
    entryKind: timesheetsEntryKindSchema,
    breakType: timesheetsClockBreakTypeSchema.nullable(),
    billingCode: timesheetsBillingCodeSchema,
    workReference: timesheetsWorkReferenceSchema.nullable(),
    notes: z.string().max(2_000).nullable(),
    source: timesheetsEntrySourceSchema,
    clockInOccurredAt: z.string().datetime({ offset: true }),
    clockInReceivedAt: z.string().datetime({ offset: true }),
    clockOutOccurredAt: z.string().datetime({ offset: true }).nullable(),
    clockOutReceivedAt: z.string().datetime({ offset: true }).nullable(),
    durationMinutes: z.number().nonnegative().nullable(),
    attentionReason: z.string().max(500).nullable(),
    revision: z.number().int().positive(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
export const timesheetsClockStatusSchema = z.strictObject({
    state: z.enum(['clocked-in', 'clocked-out']),
    currentEntry: timesheetsClockEntrySchema.nullable(),
    needsCorrectionEntry: timesheetsClockEntrySchema.nullable(),
});
export const timesheetsClockStatusResponseSchema = z.strictObject({
    data: timesheetsClockStatusSchema,
});
export const timesheetsCurrentProjectSuggestionResponseSchema = z.strictObject({
    data: z.strictObject({
        contractVersion: z.literal(timesheetsCurrentProjectSuggestionCapability),
        projectReference: timesheetsWorkReferenceSchema.pick({ id: true, label: true }).nullable(),
    }),
});
export const timesheetsClockStartWorkReferenceSchema = z.strictObject({
    type: z.literal('project'),
    id: z.string().uuid(),
});
export const timesheetsClockStartRequestSchema = z.strictObject({
    commandId: timesheetsClockCommandIdSchema,
    occurredAt: z.string().datetime({ offset: true }),
    workReference: timesheetsClockStartWorkReferenceSchema.nullable().default(null),
    notes: z.string().trim().max(2_000).nullable().optional()
        .transform((value) => (value === undefined || value === null || value === '' ? null : value)),
}).superRefine((request, context) => {
    if (request.workReference === null && request.notes === null) {
        context.addIssue({
            code: 'custom',
            path: ['notes'],
            message: 'Notes are required for shop time without a Project.',
        });
    }
});
export const timesheetsClockStopRequestSchema = z.strictObject({
    commandId: timesheetsClockCommandIdSchema,
    timeEntryId: timesheetsTimeEntryIdSchema,
    occurredAt: z.string().datetime({ offset: true }),
});
export const timesheetsClockCommandResponseSchema = z.strictObject({
    data: timesheetsClockEntrySchema,
    idempotent: z.boolean(),
});
export const timesheetsRecentEntriesQuerySchema = z.strictObject({
    limit: z.number().int().min(1).max(30).default(8),
});
export const timesheetsRecentEntriesResponseSchema = z.strictObject({
    data: z.array(timesheetsClockEntrySchema),
});
//# sourceMappingURL=timesheets-clock.contract.js.map